/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { uuid } from "@src/app/model/abstract-object";
import { Agent } from "@src/app/model/Agent";
import { BankAccount } from "@src/app/model/bankAccount";
import { Team } from "@src/app/model/team";

export class OmcSettings extends Team {
    bank_account: BankAccount;
    paymentTerms: string;
    fromEmail: string;
    replyToMail: string;
    billingAddress: string;
    agents: Agent[] = [];
    mailSendingDomain: string;
    mailSendingAccount: string;
    mailSendingName: string;
    mailReplyToDomain: string;
    purchaseAttachments: 'optional'|'required';
    purchaseApprovals: 'manual'| 'automatic';
    requestOwnerId: uuid;
    vatNumber: string;
    showOmcDashboard: string;
    /** See AI_LEVELS - this OMC's own setting, or its primary agent's where it has none. */
    aiLevel: string;
    serviceChargeLabel: string;
    creditNoteLabel: string;
    parameters: {id: uuid, name: string, value: string}[] = [];
}
